import { useEffect, useState } from "react";
import skillsService, { Skill } from "../services/skills-service";
import { API } from "aws-amplify";

const useSkills = () => {
  const [skills, setSkills] = useState<Skill[]>([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const request = skillsService.getAll();
    request
      .then((res) => {
        setSkills(res.data);
        setLoading(false);
      })
      .catch((err) => {
        if (API.isCancel(err)) return;
        setSkills([]);
        setError(err.message);
        setLoading(false);
      });

    return () => {
      API.cancel(request);
    };
  }, []);

  return { skills, error, loading, setSkills, setError };
};

export default useSkills;
